<template>
  <div>
    <div class="contract">
      <Header
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :groupService="dataContract.groupService"
      ></Header>
      <HeaderNL v-else :groupService="dataContract.groupService"></HeaderNL>
      <p class="txt-center fonsize-16 txt-tranf">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</p>
      <p class="txt-center fonsize-16">Độc lập – Tự do – Hạnh phúc</p>
      <p class="txt-center fonsize-16">***</p>

      <p class="txt-tranf txt-center fonsize-20">
        <b>PHỤ LỤC HỢP TÁC CHẤP NHẬN THANH TOÁN THẺ TỪ XA</b>
      </p>
      <p class="txt-center">
        (PLTTTTX:
        <mark>{{ dataAppendix.code }}</mark>
        )
      </p>
      <p>Căn cứ:</p>
      <ol class="form-style2">
        <li>
          Hợp đồng hợp tác chấp nhận thanh toán số:
          <mark>{{
            dataAppendix?.isNganluongContract ? dataAppendix.codeOfContract : dataContract.code
          }}</mark>
          <p>
            ký ngày
            <mark v-if="dataAppendix?.isNganluongContract">
              {{ dataAppendix?.dateSignContract | formatDate }}</mark
            >
            <mark v-else>{{
              dataContract.effectiveFromDTO
                ? dataContract.effectiveFromDTO
                : dataContract.dateSign | formatDate
            }}</mark>
          </p>
        </li>
      </ol>
      <ol class="form-style2">
        <li>Nhu cầu và khả năng của hai Bên.</li>
      </ol>
      <p>
        Hôm nay, ngày
        <mark v-if="dataAppendix.dateSignAppendixDTO">{{
          dataAppendix.dateSignAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataAppendix.dateCreatedAppendixDTO">{{
          dataAppendix.dateCreatedAppendixDTO | formatDate
        }}</mark>
        <mark v-else-if="dataContract.effectiveFromDTO">{{
          dataContract.effectiveFromDTO | formatDate
        }}</mark>
        ,
        {{
          checkCreatedDateNganluong(dataAppendix)
            ? 'tại trụ sở Công ty Cổ phần cổng trung gian thanh toán Ngân Lượng, chúng tôi gồm có:'
            : 'tại trụ sở Công ty Cổ phần Công nghệ Vi Mô, chúng tôi gồm có:'
        }}
      </p>
      <p class="fonsize-16 txt-tranf flex">
        <b v-if="!checkCreatedDateNganluong(dataAppendix)"
          >BÊN A: CÔNG TY CỔ PHẦN CÔNG NGHỆ VI MÔ</b
        >
        <b v-else>BÊN A: CÔNG TY CỔ PHẦN CỔNG TRUNG GIAN THANH TOÁN NGÂN LƯỢNG</b>
      </p>
      <p v-if="checkCreatedDateNganluong(dataAppendix)">
        Trụ sở: Tầng 3, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <p v-else>
        Trụ sở: Tầng 12A, tòa nhà VTC online, số 18 đường Tam Trinh, phường Tương Mai, thành phố Hà
        Nội, Việt Nam.
      </p>
      <div class="form form-ext">
        <p>
          Điện thoại: 024 36320986
          <span class="ml-4" v-if="!checkCreatedDateNganluong(dataAppendix)"
            >Fax: 024 36320987</span
          >
        </p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tài khoản: 11001010157634</p>
        <p v-if="!checkCreatedDateNganluong(dataAppendix)">Tại: Ngân hàng Maritimebank</p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">Mã số thuế: 0106001236</p>
        <p v-else>Mã số thuế: 0106393463</p>
        <p>
          Người đại diện:
          <b
            v-if="
              dataAppendix?.dateSignAppendixDTO ||
              dataAppendix?.dateCreatedAppendixDTO ||
              dataContract?.effectiveFromDTO
                ? (dataAppendix?.dateSignAppendixDTO ||
                    dataAppendix?.dateCreatedAppendixDTO ||
                    dataContract?.effectiveFromDTO) < new Date('2026-01-07').getTime()
                : new Date() < new Date('2026-01-07')
            "
            >ĐỖ CÔNG DIỄN</b
          >
          <b v-else>Ông NGUYỄN TIẾN LƯỢNG</b>
          <span class="ml-4"
            >Chức vụ: <b v-if="!checkCreatedDateNganluong(dataAppendix)">Tổng Giám Đốc</b
            ><b v-else>Phó Tổng Giám đốc kiêm Giám đốc BU Chuyển đổi số</b></span
          >
        </p>
        <p v-if="checkCreatedDateNganluong(dataAppendix)">
          Giấy ủy quyền số: 1302/2026/GUQ/NGANLUONG ngày 13/02/2026
        </p>
        <p>
          NVKD:
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.name
              ? dataContract.saleInfoRes.name
              : ''
          }}</b>
          <span class="ml-4">Điện thoại:</span>
          <b>{{
            dataContract.saleInfoRes && dataContract.saleInfoRes.mobile
              ? dataContract.saleInfoRes.mobile
              : ''
          }}</b>
        </p>
      </div>
      <p>và</p>
      <p class="fonsize-16 txt-tranf flex">
        <span> <b>BÊN B:</b></span>
        <mark
          ><b>{{ customerInfo.merchantName }}</b></mark
        >
      </p>
      <div class="form form-ext mb-4">
        <p>
          <span>Trụ sở: </span>
          <mark> {{ customerInfo.address }}, </mark>
        </p>
        <p>
          Website:<mark v-if="customerInfo.website"> {{ customerInfo.website }}</mark>
        </p>
        <p>
          <span>Điện thoại:</span><mark>{{ customerInfo.mobile }}</mark>
          <span class="ml-4"> Email: {{ customerInfo.email }} </span>
        </p>
        <p>
          <span>Mã số thuế:</span>
          <mark>
            {{ customerInfo.businessRegistrationNumber }}
          </mark>
        </p>
        <p class="mb-4">
          <span>Họ và tên người đại diện: </span
          ><mark
            ><b>{{ customerInfo.customerName }}</b></mark
          >
          <span class="ml-4"
            >Chức vụ: <mark v-if="customerInfo.position"> {{ customerInfo.position }}</mark></span
          >
        </p>
      </div>

      <p>Hai bên cùng thỏa thuận hợp tác và cam kết thực hiện những điều sau đây:</p>
      <p>&nbsp;</p>
      <ol class="form-style1">
        <li>
          <h1>NỘI DUNG HỢP TÁC</h1>
          <ul>
            <li>
              <b>Định nghĩa dịch vụ: </b>
              <p>
                <b>Dịch vụ thanh toán từ xa (Thank toán qua link hoặc “LinkCard”):</b> là hình thức
                thanh toán thẻ được cung cấp bởi Bên A cho phép Khách hàng có thể tiến hành thanh
                toán trực tuyến thông qua đường dẫn kết nối <b>(“Link”)</b> được tạo từ hệ thống của
                Bên A mà không cần phải có mặt trực tiếp tại Điểm chấp nhận thanh toán.
              </p>
            </li>
            <li>
              <b>Nội dung hợp tác:</b>
              <p>
                Bên B đồng ý sử dụng dịch vụ trên của Bên A cho phép Khách hàng của Bên B có thể sử
                dụng Phương thức thanh toán LinkCard trên ứng dụng của Bên A để thanh toán Hàng
                hóa/dịch vụ cho Bên B.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <h1>NGUYÊN TẮC CHẤP NHẬN THANH TOÁN LINKCARD</h1>
          <p>
            Bên A đồng ý cung cấp dịch vụ thanh toán LinkCard cho Bên B nếu Bên B đồng ý thực hiện
            đầy đủ và nghiêm túc các nguyên tắc sau:
          </p>
          <ul>
            <li>
              Cam đoan và bảo đảm tuân thủ mọi quy định của pháp luật, quy định tại Hợp đồng đã kí
              kết giữa hai Bên và các quy định khác có liên quan để tiến hành kinh doanh hàng hóa,
              dịch vụ và hoạt động tại Bên B. Bên B đồng ý chịu mọi trách nhiệm đối với các vấn đề
              có thể phát sinh từ việc thiếu bất kỳ giấy phép, phê chuẩn và/hoặc chấp thuận nào để
              tiến hành kinh doanh hàng hóa, dịch vụ nêu trên.
            </li>
            <li>
              Cam kết tất cả hàng hóa, dịch vụ cung cấp bởi Bên B là hợp pháp, đủ điều kiện kinh
              doanh và lưu thông theo quy định pháp luật tại từng thời điểm. Hàng hóa, dịch vụ có
              xuất xứ rõ ràng, đảm bảo chất lượng như đã cam kết. Ngoài các giấy phép, phê chuẩn của
              Bên B nhằm đáp ứng điều kiện kinh doanh theo quy định tại Mục 1, Bên B cam kết có đầy
              đủ các chứng từ, tài liệu, giấy phép con, phê chuẩn cần thiết đối với hàng hóa, dịch
              vụ trong lưu thông, bao gồm nhưng không giới hạn chứng từ thể hiện xuất xứ, chất lượng
              (CO, CQ), vận đơn, giấy phép nhập khẩu, xuất khẩu.
            </li>
            <li>
              Giá mua hàng hóa, dịch vụ thông qua hình thức thanh toán LinkCard không cao hơn so với
              các hình thức thanh toán khác, giá mua bán hàng hóa, dịch vụ phản ánh đúng giá trị thị
              trường hợp lý; đảm bảo tuân thủ các quy định về thanh toán thẻ của pháp luật, Tổ chức
              thẻ và quy định, chính sách của Ngân hàng nhà nước, Ngân hàng thương mại qua các thời
              kì.
            </li>
            <li>
              Thực hiện đúng thỏa thuận mua bán, hoạt động mua bán;
              <p>
                - Bên B phải đảm bảo cung cấp hàng hóa, dịch vụ là có thật; tư vấn đầy đủ về hàng
                hóa, dịch vụ mua bán với chủ thẻ bao gồm: số tiền thanh toán, hình thức thanh toán,
                phương thức và chi phí giao hàng trước khi chủ thẻ đồng ý thanh toán
              </p>
              <p>
                - Bên B cần công khai chính sách hoàn huỷ, đổi trả sản phẩm, dịch vụ; chính sách
                khác liên quan đến giao dịch và có thông báo, tư vấn với chủ thẻ rõ ràng trước khi
                thanh toán
              </p>
              <p>
                - Bên B cần đảm bảo lưu trữ đầy đủ hóa đơn, chứng từ của các giao dịch thanh toán
                thẻ từ xa. Thời gian lưu trữ: <b>540 ngày kể từ ngày giao dịch</b>
              </p>
              <p>
                - Bên B phải chủ động đào tạo nhân viên về các biện pháp an toàn, phương pháp chống
                gian lận, cách nhận diện các dấu hiệu nghi ngờ, cách thức lưu trữ chứng từ trong quá
                trình thanh toán
              </p>
              <p>
                - Bên B đảm bảo tuân thủ các tiêu chuẩn và quy định về bảo mật dữ liệu cá nhân của
                Chủ thẻ. Chủ thẻ (“Khách hàng”) phải là người nhập các thông tin thẻ, thông tin cá
                nhân trong quá trình thanh toán. Không được lưu trữ, hay cung cấp thông tin thẻ tín
                dụng, thông tin cá nhân của khách hàng.
              </p>
              <p>
                - Không cấu kết, lôi kéo Chủ thẻ (“Khách hàng”) nhằm sử dụng thiết bị và phương thức
                thanh toán của Bên A để thực hiện các hành vi vi phạm pháp luật bao gồm nhưng không
                giới hạn thực hiện giao dịch khống, nâng giá sản phẩm, rửa tiền, tài trợ khủng bố.
              </p>
              <p>
                - Đảm bảo tuân thủ các nghĩa vụ khác theo Hợp đồng chấp nhận thanh toán đã kí kết
                giữa hai Bên, các quy định khác của Tổ chức thẻ, Ngân hàng nhà nước, Ngân hàng
                thương mại và của pháp luật hiện hành trong hoạt động sử dụng và thanh toán bằng
                phương thức thanh toán thẻ từ xa qua thiết bị thanh toán thẻ mPos.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <h1>PHÍ DỊCH VỤ</h1>
          <div class="table-responsive">
            <table>
              <thead>
                <tr class="bg-head">
                  <th>STT</th>
                  <th>Loại thẻ</th>
                  <th>Mức phí/01 giao dịch</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <td>1</td>
                  <td>Thẻ Visa, Master, JCB phát hành tại Việt Nam</td>
                  <td>{{ fee }}%</td>
                </tr>
                <tr class="text-center">
                  <td>2</td>
                  <td>Thẻ AMEX phát hành tại Việt Nam</td>
                  <td>{{ amexFee || '2,8' }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <b>Lưu ý:</b>
            <ul style="list-style: disc !important">
              <li>Mức phí trên đã bao gồm VAT</li>
              <li>Loại Thẻ AMEX phát hành tại Việt Nam: áp dụng từ 10/12/2025</li>
            </ul>
          </div>
        </li>
        <li>
          <h1>CÁC HÀNH VI NGHIÊM CẤM</h1>
          <p>
            Khi đồng ý sử dụng dịch vụ Thanh toán thẻ từ xa của Bên A, Bên B không được thực hiện
            các hành vi dưới đây:
          </p>
          <ol class="form-style2">
            <li>
              Hỗ trợ, giúp đỡ, ủng hộ hoặc hợp tác với Khách hàng nhằm quy đổi hàng hóa, dịch vụ ra
              tiền mặt; giao hoặc cung cấp sai hàng hóa so với hàng hóa, dịch vụ đã thỏa thuận với
              Khách hàng.
            </li>
            <li>
              Cho phép Khách hàng thanh toán thẻ tín dụng tại Điểm chấp nhận thanh toán của Bên B để
              lấy tiền mặt thay vì để thanh toán cho việc mua hàng hóa của Bên B.
            </li>
            <li>
              Hợp tác với các đối tượng lừa đảo/ nhân viên bán hàng/ nhân viên VIMO/ bất cứ người
              nào để làm giả hợp đồng mua bán, cung cấp dịch vụ với Khách hàng nhằm thanh toán qua
              hệ thống của Bên A.
            </li>
            <li>
              Gợi ý Khách hàng chỉnh sửa, thay đổi thông tin Khách hàng, thông tin trên hợp đồng
              cung cấp hàng hóa, dịch vụ.
            </li>
            <li>
              Nhận phí hoặc tăng giá sản phẩm hàng hóa, dịch vụ thông qua thanh toán bằng phương
              thức quẹt thẻ trên thiết bị thanh toán thẻ mPos.
            </li>
            <li>
              Thực hiện hoàn trả không đúng với quy trình của Bên A (hoàn trả tiền mặt, chuyển
              khoản,...)
            </li>
          </ol>
        </li>
        <li>
          <h1>QUY ĐỊNH VỀ PHỐI HỢP XỬ LÝ TRANH CHẤP, KHIẾU NẠI</h1>
          <ol class="form-style2">
            <li>Bên B phải cung cấp đầu mối xử lý khiếu nại công khai với khách hàng và Bên A</li>
            <li>
              Bên B có trách nhiệm giải quyết trực tiếp với Khách hàng mọi tranh chấp phát sinh.
              Phối hợp cung cấp các chứng từ cần thiết để chứng minh giao dịch thực hiện là hợp lệ
              và đúng quy định, đồng thời đảm bảo nghĩa vụ cung cấp hàng hóa, dịch vụ đúng số lượng,
              chất lượng, phương thức giao dịch như đã thỏa thuận với Khách hàng.
            </li>
            <li>
              Bên B đồng ý miễn trừ và bồi thường thiệt hại cho Bên A đối với bất cứ tranh chấp với
              Khách hàng hay bên thứ ba bất kỳ, các cuộc điều tra của cơ quan nhà nước có thẩm
              quyền, Tổ chức thẻ và/hoặc hình phạt liên quan đến giá cả, chất lượng, dịch vụ liên
              quan đến việc mua bán hàng hóa, vi phạm sở hữu trí tuệ, nhãn hiệu, và xuất xứ hàng
              hoá, dịch vụ là đối tượng sử dụng phương thức thanh toán bằng mPos trong phạm vi Hợp
              Đồng.
            </li>
          </ol>
        </li>
        <li>
          <h1>ĐIỀU KHOẢN THI HÀNH</h1>
          <ol class="form-style2">
            <li>
              Phụ lục này là bộ phận không thể tách rời của Hợp đồng và các điều khoản khác của Hợp
              đồng vẫn được giữ nguyên. Các bên cam kết tuân thủ các quy định trong Phụ lục Hợp đồng
              này.
            </li>
            <li>
              Phụ lục này có hiệu lực kể từ ngày đại diện hợp pháp của hai Bên tham gia ký kết. Thời
              hạn hiệu lực của Phụ lục này được xác định theo thời hạn hiệu lực của Hợp đồng nêu
              trên trừ khi hai bên có thỏa thuận khác bằng văn bản.
            </li>
            <li>
              Phụ lục này được lập thành 02 (hai) bản, có nội dung và giá trị pháp lý như nhau, mỗi
              Bên giữ 01 (một) bản.
            </li>
          </ol>
        </li>
      </ol>
      <Footer
        v-if="!checkCreatedDateNganluong(dataAppendix)"
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></Footer>
      <FooterNL
        v-else
        :dataContract="dataContract"
        :dataAppendix="dataAppendix"
        :isAppendix="true"
      ></FooterNL>
    </div>
  </div>
</template>

<script>
  import Header from '../block/header.vue'
  import Footer from '../block/footer.vue'
  import HeaderNL from '../block/headerNL.vue'
  import FooterNL from '../block/footerNL.vue'
  export default {
    props: ['dataContract', 'appendix'],
    components: {
      Header,
      Footer,
      HeaderNL,
      FooterNL,
    },
    data() {
      return {}
    },
    computed: {
      customerInfo() {
        return this.dataContract.customerInfoRes ?? this.dataContract.customerInfoCommon ?? {}
      },
      dataAppendix() {
        return (
          this.appendix ?? this.dataContract.lstAppendixLinkCards.find(e => e.isCreatedWithContract)
        )
      },
      fee() {
        return this.appendix.appendixLinkCard.fee ?? this.dataContract.lstAppendixLinkCards.fee
      },
      amexFee() {
        return (
          this.appendix.appendixLinkCard.amexFee ?? this.dataContract.lstAppendixLinkCards.amexFee
        )
      },
    },
  }
</script>

<style scoped src="@/assets/css/style-review.css"></style>
